enum NoteType {
	General = 1,
    Call = 2,
    Meeting = 3
}

export default NoteType;